export class requestRtbData {
    dealerGroupId:string;
    dealerShipId: number;
    year: number;
    month: number;
    quarter: number;
    viewType: string;
    constructor (data) {
        this.dealerGroupId = data.dealerGroupId;
        this.dealerShipId = data.dealerShipId;
        this.year = data.year;
        this.month = data.month;
        this.quarter = data.quarter;
        this.viewType = data.viewType;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/req/request-get-rtb-data.ts